/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: actions.ts
 * Class: actions.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { ActionTree } from 'vuex';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import {
  DonationCreateRequest, DonationInfoResponse, DonationState, DonationSuccessResponse,
} from './types';
import { RootState } from '../types';
import { ApiEndpointEnum, getApiRequestConfig } from '../../config/network';

export const actions: ActionTree<DonationState, RootState> = {
  resetDonation({ commit }): void {
    commit('donationReset');
  },
  async createDonation(
    { commit },
    payload: DonationCreateRequest,
  ): Promise<DonationSuccessResponse> {
    commit('donationProcessing');

    return new Promise((resolve, reject) => {
      const requestConfig: AxiosRequestConfig = getApiRequestConfig(ApiEndpointEnum.Donation);
      // adding the recaptcha token here from the payload
      requestConfig.headers = Object.assign(requestConfig.headers, { 'X-Recaptcha-Token': payload.recaptcha });

      this.state.$http.post(`donation/${payload.donationHash}/${encodeURIComponent(payload.userName)}`,
        {
          amount: payload.amount,
          purpose: payload.purpose,
        },
        requestConfig)
        .then((response: AxiosResponse<DonationSuccessResponse>) => {
          const donationSuccessResponse: DonationSuccessResponse = response && response.data;
          commit('donationProcessed', donationSuccessResponse);
          resolve(donationSuccessResponse);
        }, (error) => {
          commit('donationError', { code: error.response.status, message: error.response.data.message });
          reject(error);
        });
    });
  },
  async fetchDonationInfo(
    { commit },
    payload: { donationHash: string; userName: string },
  ): Promise<DonationInfoResponse> {
    commit('dataLoading');

    return new Promise((resolve, reject) => {
      axios(`donation/${payload.donationHash}/${encodeURIComponent(payload.userName)}`, getApiRequestConfig(ApiEndpointEnum.Donation))
        .then((response: AxiosResponse<DonationInfoResponse>) => {
          const donationInfoResponse: DonationInfoResponse = response && response.data;
          commit('dataLoaded', donationInfoResponse);
          resolve(donationInfoResponse);
        }, (error) => {
          commit('dataError', { code: error.response.status, message: error.response.data.message });
          reject(error);
        });
    });
  },
};
